import { errorTracking } from "./errorTracking";

const isErrorBeingTracked = (error: Error): boolean => {
  const trackedKey = "__tracked_by_app";

  if ((error as any)[trackedKey]) {
    return true;
  }

  (error as any)[trackedKey] = true;
  return false;
};

const setupGlobalErrorTracking = (): void => {
  window.addEventListener("error", (event) => {
    if (event.error && !isErrorBeingTracked(event.error)) {
      errorTracking(event.error, {
        componentName: "GlobalErrorHandler",
        additionalData: {
          errorType: "uncaught",
          message: event.message,
          filename: event.filename,
          lineno: event.lineno,
          colno: event.colno,
        },
      });
    }
  });

  window.addEventListener("unhandledrejection", (event) => {
    if (event.reason instanceof Error) {
      if (!isErrorBeingTracked(event.reason)) {
        errorTracking(event.reason, {
          componentName: "GlobalPromiseHandler",
          additionalData: {
            errorType: "unhandledrejection",
          },
        });
      }
    } else {
      const error = new Error(
        typeof event.reason === "string"
          ? event.reason
          : "Unhandled Promise rejection with non-Error reason"
      );

      errorTracking(error, {
        componentName: "GlobalPromiseHandler",
        additionalData: {
          errorType: "unhandledrejection",
          reason:
            typeof event.reason === "object"
              ? JSON.stringify(event.reason)
              : String(event.reason),
        },
      });
    }
  });

  const originalConsoleError = console.error;
  console.error = (...args) => {
    originalConsoleError.apply(console, args);

    if (args.length > 0 && args[0] instanceof Error) {
      if (!isErrorBeingTracked(args[0])) {
        errorTracking(args[0], {
          componentName: "ConsoleError",
          additionalData: {
            errorType: "console.error",
            additionalArgs: args
              .slice(1)
              .map((arg) =>
                typeof arg === "object" ? JSON.stringify(arg) : String(arg)
              )
              .join(", "),
          },
        });
      }
    }
  };
};

export default setupGlobalErrorTracking;
